import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { h4, paragraphRegular, paragraphSmall } from '@helpers/typography';
import svgCurve from '@img/icons/background/mep-technical-curve.svg?url';
import styled from 'styled-components';
const Outer = styled.div `
  display: flex;
  overflow: hidden;
  height: 100%;
  position: relative;

  &[data-site='ess'] {
    --bgColour: ${brand.global.white};
    --cornerColour: ${brand.ess.secondary.lightestGrey};
    --borderColour: ${brand.ess.secondary.darkGrey};
    --fgColour: ${brand.ess.primary};
    --typeBgColour: ${brand.ess.secondary.darkGrey};
    --typeColour: ${brand.global.white};
    --lockBgColour: ${brand.ess.secondary.lightestGrey};
    --lockColour: ${brand.ess.secondary.midGrey};
    --countBgColour: ${brand.ess.secondary.lightestGrey};
    --countColour: ${brand.ess.secondary.darkGrey};
  }

  &[data-site='ess'][data-featured='true'] {
    --borderColour: ${brand.global.red};
    --typeBgColour: ${brand.global.red};
  }

  &[data-site='mep'] {
    --bgColour: ${brand.global.white};
    --borderColour: ${brand.mep.secondary.midGrey};
    --fgColour: ${brand.mep.primary};
    --typeBgColour: ${brand.mep.secondary.darkestGrey};
    --typeColour: ${brand.global.white};
    --lockBgColour: ${brand.mep.secondary.midGrey};
    --lockColour: ${brand.mep.secondary.darkestGrey};
    --countBgColour: ${brand.mep.secondary.darkestGrey};
    --countColour: ${brand.global.white};
  }
`;
const Container = styled.div `
  padding: 64px ${fluid(20, 45)} ${fluid(20, 45)};
  background-color: var(--bgColour);
  color: var(--fgColour);
  height: 100%;
  width: 100%;
  border: 2px solid var(--borderColour);

  ${Outer}[data-site='ess'][data-featured='true'] & {
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -1px;
      right: -1px;
      height: ${fluid(36, 64)};
      width: ${fluid(36, 64)};
      transform: translate(50%, 50%) rotate(45deg);
      border-left: 2px solid var(--borderColour);
      background-color: var(--cornerColour);
    }
  }

  ${Outer}[data-site='ess'][data-featured='false'] & {
    &::before {
      content: '';
      position: absolute;
      right: 2px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 95px solid transparent;
      border-right: 95px solid ${brand.ess.secondary.lightestGrey};
      border-bottom: 95px solid transparent;
    }
  }

  @media ${from(Device.TabletLarge)} {
    ${Outer}[data-site='mep'] & {
      border-radius: 8px;
      background-image: url(${svgCurve});
      background-repeat: no-repeat;
      background-position: right bottom;
      background-size: contain;
    }
  }
`;
const TypeContainer = styled.div `
  position: absolute;
  top: 2px;
  right: 2px;
  display: flex;

  ${Outer}[data-featured='true'] & {
    top: 0;
    right: 0;
  }
`;
const LockContainer = styled.div `
  width: 36px;
  height: 36px;
  background-color: var(--lockBgColour);
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${from(Device.TabletLarge)} {
    width: 46px;
    height: 46px;
  }

  ${Outer}[data-site='mep'] & {
    border-radius: 0 0 0 8px;
  }

  svg {
    color: var(--lockColour);
    width: 19px;
    height: 22px;
  }
`;
const Type = styled.div `
  ${paragraphRegular};
  ${fonts.daxWide.medium};
  display: flex;
  align-items: center;
  background-color: var(--typeBgColour);
  color: var(--typeColour);
  padding: 0 20px;
  height: 36px;

  @media ${from(Device.TabletLarge)} {
    height: 46px;
  }

  ${Outer}[data-site='mep'] & {
    border-radius: 0 8px 0 0;
  }
`;
const IconContainer = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  svg {
    height: 50px;
    color: ${brand.ess.secondary.lightestGrey};
  }
`;
const Icon = styled.div `
  svg {
    position: relative;
    height: 40px;

    ${Outer}[data-site='ess'] & {
      left: -10px;
    }
  }
`;
const ContentContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
`;
const Title = styled.h3 `
  ${h4};

  margin-bottom: 20px;

  ${Outer}[data-site='mep'] & {
    ${fonts.museoSlab.medium};
  }
`;
const Description = styled.div `
  ${paragraphRegular};

  max-width: 686px;
  margin-bottom: 24px;
`;
const CTAContainer = styled.div `
  display: flex;
  grid-gap: 20px;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: auto;

  @media ${until(Device.Tablet)} {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const CTA = styled.div ``;
const Count = styled.div `
  ${paragraphSmall};
  ${fonts.daxWide.medium};
  padding: 5px 10px;
  background-color: var(--countBgColour);
  color: var(--countColour);
  margin-bottom: 0;
`;
const TechnicalDocumentCardStyles = {
    Container,
    Description,
    ContentContainer,
    Title,
    Outer,
    TypeContainer,
    LockContainer,
    Type,
    IconContainer,
    Icon,
    Count,
    CTAContainer,
    CTA,
};
export default TechnicalDocumentCardStyles;
